module.exports = __webpack_public_path__ + "media/demo.6f8e5c9c.mp4";